import {
  GET_POS_INTEGRATIONS,
  SET_POS_INTEGRATIONS,
  GET_POS_INTEGRATIONS_LIST,
  SET_POS_INTEGRATIONS_LIST,
  SET_POS_INTEGRATION,
  ADD_POS_INTEGRATION,
  EMPTY_POS_INTEGRATION,
  DELETE_POS_INTEGRATION,
  EDIT_POS_INTEGRATION,
  UPDATE_POS_INTEGRATION,
  SET_POS_INTEGRATION_FILTER,
  API_ERROR,
} from "./actionTypes";

export const getPosIntegrations = () => {
  return {
    type: GET_POS_INTEGRATIONS,
    payload: {},
  };
};

export const setPosIntegrations = (data) => {
  return {
    type: SET_POS_INTEGRATIONS,
    payload: data,
  };
};

export const setPosIntegration = (data) => {
  return {
    type: SET_POS_INTEGRATION,
    payload: data,
  };
};

export const addPosIntegration = (history) => {
  return {
    type: ADD_POS_INTEGRATION,
    payload: { history },
  };
};

export const emptyPosIntegration = () => {
  return {
    type: EMPTY_POS_INTEGRATION,
    payload: {},
  };
};

export const deletePosIntegration = (id) => {
  return {
    type: DELETE_POS_INTEGRATION,
    payload: { id },
  };
};

export const editPosIntegration = (id) => {
  return {
    type: EDIT_POS_INTEGRATION,
    payload: { id },
  };
};

export const updatePosIntegration = (history, id) => {
  return {
    type: UPDATE_POS_INTEGRATION,
    payload: { history, id },
  };
};

export const setPosIntegrationFilter = (data) => {
  return {
    type: SET_POS_INTEGRATION_FILTER,
    payload: data,
  };
};

export const getPosIntegrationsList = () => {
  return {
    type: GET_POS_INTEGRATIONS_LIST,
    payload: {},
  };
};

export const setPosIntegrationsList = (data) => {
  return {
    type: SET_POS_INTEGRATIONS_LIST,
    payload: data,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
